import { GlobalStyles } from '@mui/material';
import React from 'react';

export function GlobalStyle() {
  return (
    <GlobalStyles
      styles={{
        '::-webkit-scrollbar': {
          border: 'none',
          width: '6px',
          height: '6px'
        },
        '::-webkit-scrollbar-thumb': {
          border: 'none',
          backgroundColor: '#C1C1C1',
          borderRadius: '6px',
          borderWidth: '2px',
          width: '6px'
        },
        '::-webkit-scrollbar-track': {
          border: 'none',
          backgroundColor: 'transparent'
        },
        '::-webkit-scrollbar-track:hover': {
          backgroundColor: '#F5F6F7'
        },
        '*': {
          '-webkit-font-smoothing': 'antialiased',
          '-moz-osx-font-smoothing': 'grayscale',
          'text-rendering': 'optimizeLegibility',
          // Safari only
          '@media not all and (min-resolution: 0.001dpcm)': {
            '@supports (-webkit-touch-callout: none)': {
              '*': {
                '-webkit-text-stroke': '0.1px'
              }
            }
          }
        }
      }}
    />
  );
}
